<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
export default {
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      height: `${document.documentElement.clientHeight}`,
      isRouterAlive: true,
      rafId: null
    };
  },
  created() {
    this.updateWindowSize();
  },
  mounted() {
    // 【关键修复】使用 addEventListener 监听，不会被覆盖
    window.addEventListener('resize', this.handleResize);
    // 监听页面关闭（保留你原来的）
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    this.doIt();
  },
  methods: {
    doIt() {
      //此处添加500毫秒延迟，目的是等待历史记录变化之后再添加空地址，使空地址能准确添加到栈顶，防止出错
      setTimeout(() => {
        if (!(history.state && history.state.target == "Final")) {
          window.history.pushState(
            { target: "MeanSure", random: Math.random() },
            "",
            location.href
          );
          window.history.pushState(
            { target: "Final", random: Math.random() },
            "",
            location.href
          );
        }
        window.addEventListener(
          "popstate",
          function(e) {
            if (e.state && e.state.target == "MeanSure") {
              //此处可调用一些自定义的操作，例如弹窗提示之类的，最后根据实际需要可调用上面三个函数中的任何一个，用于决定当前自定义操作完成之后，需要停留在本页面，还是回退，还是跳转到其他页面
              // this.doSomething();
              //alert('不支持回退');
              // stay(); //如此操作会停留在本页面
              history.forward();
              //back();如此操作会无副作用回退到上一级
              //toUrl（'http://www.baidu.com'）;如此操作会执行完之定义操作之后跳转到百度
            }
          },
          false
        );
      }, 500);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    // 真正执行更新的函数
    updateWindowSize() {
      const height = document.documentElement.clientHeight;
      const width = document.body.clientWidth;

      // 提交到 Store
      this.$store.commit('setMainHeight', height);
      this.$store.commit('setMainWidth', width);

      // 如果你需要存 localStorage，可以在这里加
      // localStorage.setItem('tableHeight', height);

      // 可以打印看看，确认每次都在变化
      // console.log('高度已更新：', height);
    },
    handleResize() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId); // 如果上一帧还没执行，取消掉，避免堆积
      }
      this.rafId = requestAnimationFrame(() => {
        this.updateWindowSize();
        this.rafId = null;
      });
    },
    windowHeight(value) {
      this.$store.commit("setMainHeight", value);
      // do something...
    }
  },
  watch: {
    height(val) {
      if (!this.timer) {
        this.height = val;
        this.timer = true;
        let _this = this;
        setTimeout(function() {
          _this.timer = false;
        }, 500);
      }
      // 这里可以添加修改时的方法
      this.windowHeight(val);
    },
    '$route' (to, from) {
      if  (to.path == "/collectMoney") {
        let arr = JSON.parse(localStorage.getItem("cashierMenu"))
        this.$router.push(arr[0].url)
      } else if (to.path == "/manage") {
        let arr = JSON.parse(localStorage.getItem("shopMenu"))
        this.$router.push(arr[0].url)
      } else if (to.path == "/dataList") {
        let arr = JSON.parse(localStorage.getItem("dataMenu"))
        this.$router.push(arr[0].url)
      }
	} 
  }
};
</script>
<style>
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css"; /*深色主题*/
/*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>
